import { useQuery } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { mapCategoryRow, mapGroupRow, VIRTUAL_UNGROUPED_ROW } from './useCategoryGroupsMappers'
import { getSpendControlCategories } from 'SpendControl/endpoints'
import type { CardPartner } from 'SpendControl/endpoints/spend-control'
import type { SpendControlRow } from 'SpendControl/SpendControlTable'

export const useCategoryGroups = ({ partner }: { partner: string | undefined }) => {
  const { data, isLoading } = useQuery({
    queryKey: [SPEND_CATEGORIES, partner],
    queryFn: () => getSpendControlCategories(partner as CardPartner),
    enabled: Boolean(partner),
  })

  return {
    data:
      data &&
      ([
        ...(data.categories ?? []).flatMap((group) => {
          const uniqueCats = [...new Map(group.categories.map((c) => [c.id, c])).values()]
          return [mapGroupRow(group, uniqueCats), ...uniqueCats.map((cat) => mapCategoryRow(cat, group.id))]
        }),
        ...((data.ungroupedCategories ?? []).length > 0
          ? [VIRTUAL_UNGROUPED_ROW, ...(data.ungroupedCategories ?? []).map((cat) => mapCategoryRow(cat, VIRTUAL_UNGROUPED_ROW.id))]
          : []),
      ] as SpendControlRow[]),
    isLoading,
  }
}
